import { Component } from "@angular/core";
import { BsLocaleService, DateFormatter } from "ngx-bootstrap/datepicker";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { UsuarioService } from "src/app/services/usuario-service";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { PedidoService } from "src/app/services/pedido-service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ConfiguracoesSite } from "src/app/entities/configuracoesSite";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead";
import { CurrencyPipe } from "@angular/common";
import { Configuracoes } from "src/app/entities/configuracoes";
import { ProductService } from "src/app/services/product-service";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { InitProvider } from "src/app/services/init-provider";
declare var $: any;
@Component({
  selector: "app-page-vendas",
  templateUrl: "./page-vendas.component.html",
  styleUrls: ["./page-vendas.component.css"],
})
export class PageVendasComponent {
  public list: number = 0;
  private format = new DateFormatter();
  tipo = 'analitico'
  elementos
  vendas: any[] = [];
  filiais: any[] = [];
  estoque: any[] = [];
  pageable: boolean = true;
  public formSearch: FormGroup;
  pedidos: any[] = [];
  pageNumber = 1;
  public mapItens;
  public mapProdutos;
  pagTotais: number = 0;
  public tablePedidoView;
  totalElements: 0;
  qrCode: any = {};
  pedido: any;
  pedidoAprove: any;
  nome: string;
  pageOrder: number = 0;
  typingCliente: string;
  clientes: Observable<any[]>;
  SITE: ConfiguracoesSite;
  private currencyPipe: CurrencyPipe = new CurrencyPipe("pt-BR");
  public ranges: any = [
    {
      value: [
        new Date(new Date().setDate(new Date().getDate() - 7)),
        new Date(),
      ],
      label: "Últimos 7 Dias",
    },
    {
      value: [
        new Date(new Date().setMonth(new Date().getMonth() - 1)),
        new Date(),
      ],
      label: "Último mês",
    },
    {
      value: [
        new Date(new Date().setMonth(new Date().getMonth() - 6)),
        new Date(),
      ],
      label: "Últimos 6 meses",
    },
  ];

  constructor(
    private localeService: BsLocaleService,
    public usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    public pedidoService: PedidoService,
    private sanitizer: DomSanitizer,
    public productService: ProductService,
    public initProvider: InitProvider,
    private toastService: ToastrService
  ) {

    this.SITE = Configuracoes.SITE;
    console.log(this.SITE)
    this.localeService.use("pt-br");
    this.formSearch = this.formBuilder.group({
      data: [[]],
      cliente: [""],
      filial: [""],
      status: [""],
      usuario: [""],
      pedido: [""],
      tipo: ["analitico"],
    });
    this.clientes = Observable.create((observer: any) => {
      if (!this.usuarioService.loading) {
        this.usuarioService.getClientes(
          {
            busca: this.typingCliente,
            id_usuario: this.initProvider.usuario.id,
          },
          function (resp) {
            observer.next(resp);
          }.bind(this)
        );
      }
    });
    this.elementos = this.initProvider.usuario.nivel[1].elementos.filter(i => i.listar)
  }
  onSelectCliente(event: TypeaheadMatch): void {
    this.formSearch.controls.cliente.setValue(event.item.id);
    $("#cliente").blur();
    $("#cliente").removeClass("is-valid is-invalid");
    $("#cliente").addClass("is-valid");
    $("#btnFormSearch").focus();
  }
  typeaheadNoResults(event: boolean): void {
    //if(event){
    this.formSearch.controls.cliente.setValue("");
    $("#cliente").removeClass("is-valid is-invalid");
    $("#cliente").addClass("is-invalid");
    //}
  }
  setPage(value) {
    this.list = value;
    if (value === 3) {
      this.usuarioService.getFiliais(100, (e) => {
        this.filiais = e;
      });
    }
  }
  onSubmit() {
  }

  getSafeImageUrl() {
    // Certifique-se de qrCode.image_qrcode contém a string base64 da imagem
    if (this.qrCode.image_qrcode) {
      const imageUrl = "data:image/png;base64," + this.qrCode.image_qrcode;
      return this.sanitizer.bypassSecurityTrustResourceUrl(imageUrl);
    }
  }
  pageChanged(e) {
    if (this.pageNumber !== e.page) {
      this.pageNumber = e.page;
      this.getEstoque();
    }
  }

  pageOrderChanged(e) {
    if (this.pageOrder !== e.page) {
      this.pageOrder = e.page;
      this.getPedidos();
    }
  }
  replaceString(s) {
    if (s == null) {
      return ''
    }
    return s.replace("_", " ")
  }

  getIdPedido(pedido) {
    if (!pedido.reservado_erp) {
      this.toastService.error("Não é possivel aprovar um pedido com reserva pendente", "Vendas", {
        timeOut: 4000,
      });
      return null
    }
    if (pedido.status_pagamento !== 'pos_pago' && pedido.status_pagamento !== 'pre_pago') {
      this.toastService.error("Não é possivel aprovar um pedido aguardando pagamento", "Vendas", {
        timeOut: 4000,
      });
      return null
    }
    if (pedido.limite_credito !== null && pedido.limite_credito < pedido.total && pedido.status_pagamento !== 'pre_pago') {
      this.toastService.error("Valor do pedido excede o limite de crédito", "Vendas", {
        timeOut: 4000,
      });
      return null
    }
    $("#confirmAprovaModal").modal("show");
    this.nome = pedido.id;
    this.pedidoAprove = pedido
  }


  showPedidoFinalizado(p: any) {
    this.pedidoService.getPedidoId(p.pedido, (res) => {
      this.pedido = res;
      this.mapaItensEProdutos();
      this.tablePedidoView = "";
      this.productService.findByMap(
        this.mapProdutos,
        function (resp) {
          if (resp) {
            let refs = [];
            this.mapProdutos = resp;
            for (let key of Object.keys(this.mapProdutos)) {
              refs.push({
                id: this.mapProdutos[key].id,
                ref: this.mapProdutos[key].referencia,
              });
            }
            refs.sort(this.sort1);
            refs.forEach((r) => {
              this.tablePedidoView += this.table1(
                this.mapProdutos[r.id],
                this.mapItens[r.id]
              );
            });
          }
        }.bind(this)
      );
    });
  }
  table1(produto, itens) {
    let mapCor = {};
    itens.forEach((i) => {
      if (mapCor[i.cor]) {
        mapCor[i.cor].push(i);
      } else {
        mapCor[i.cor] = [i];
      }
    });
    let head = "<tr><td>COR</td>";
    let rows = [];
    let totalTamanhos = {};
    let totalQtde = 0;
    let totalPreco = 0;
    let totalTotal = 0;
    for (let key of Object.keys(mapCor)) {
      let grade = "<tr><td>" + mapCor[key][0].corDescricao + "</td>";
      let qtde = 0;
      let total = 0;
      produto.tamanhos.forEach((t) => {
        let tamanho = 0;
        mapCor[key].forEach((mC) => {
          if (mC.tamanho == t.tamanho) {
            tamanho = mC.quantidade;
            qtde += mC.quantidade;
            total += mC.total;
            if (totalTamanhos[t.tamanho]) {
              totalTamanhos[t.tamanho] += mC.quantidade;
            } else {
              totalTamanhos[t.tamanho] = mC.quantidade;
            }
          }
        });
        grade += "<td>" + tamanho + "</td>";
      });
      totalQtde += qtde;
      totalPreco += total / qtde;
      totalTotal += total;
      grade += "<td>" + qtde + "</td>";
      grade +=
        "<td>" + this.currencyPipe.transform(total / qtde, "", "") + "</td>";
      grade +=
        "<td>" + this.currencyPipe.transform(total, "", "") + "</td></tr>";
      rows.push(grade);
    }
    let grade = "<tr><td></td>";
    produto.tamanhos.forEach((t) => {
      grade +=
        "<td>" +
        (totalTamanhos[t.tamanho] ? totalTamanhos[t.tamanho] : "") +
        "</td>";
    });
    grade += "<td><b>" + totalQtde + "</b></td>";
    grade +=
      "<td><b>" + this.currencyPipe.transform(totalPreco, "", "") + "</b></td>";
    grade +=
      "<td><b>" +
      this.currencyPipe.transform(totalTotal, "", "") +
      "</b></td></tr>";
    rows.push(grade);
    produto.tamanhos.forEach((t) => {
      head += "<td>" + t.tamanho + "</td>";
    });
    head += "<td>QTDE</td>";
    head += "<td>PREÇO</td>";
    head += "<td>TOTAL</td></tr>";
    return `<div class="table-responsive">
      <table class="table table-hover table-condensed table-striped table-sm table-responsive-xs">
        <thead class="table-head">
            <tr>
                <th colspan="5">${produto.referencia} - ${produto.descricao
      }</th>
            </tr>
        </thead>
        <tbody>
            ${head}
            ${rows.join("")}
        </tbody>
      </table>
    </div>`;
  }
  mapaItensEProdutos() {
    this.mapItens = {};
    this.pedido.itens.forEach((i) => {
      if (this.mapItens[i.produto]) {
        this.mapItens[i.produto].push(i);
      } else {
        this.mapItens[i.produto] = [i];
      }
    });
    this.mapProdutos = {};
    this.pedido.itens.forEach((i) => {
      this.mapProdutos[i["produto"] as any] = null;
    });
  }
  getPix(id) {
    this.usuarioService.getPix(
      {
        pedido_cliente: id,
      },
      function (resp) {
        this.qrCode = resp;
        $("#pixModal").modal("show");
      }.bind(this),
      function (resp) {
        console.log(resp)
        this.toastService.info("Algo deu errado!", "Pix", {
          timeOut: 4000,
        });
      }.bind(this),
    );
  }
  consultaPix(id) {
    this.usuarioService.consultaPix(
      {
        pedido_cliente: id,
      },
      function (resp) {
        this.qrCode = resp;
        $("#pixModal").modal("show");
      }.bind(this),
      function (resp) {
        let res = resp._body
        console.log(JSON.parse(res).detail)
        this.toastService.info(JSON.parse(res).detail, "Pix", {
          timeOut: 4000,
        });
      }.bind(this),
    );
  }
  sort1(a, b) {
    if (a.ref.toLowerCase() > b.ref.toLowerCase()) {
      return 1;
    } else if (a.ref.toLowerCase() < b.ref.toLowerCase()) {
      return -1;
    } else {
      return 0;
    }
  }
  getVendas() {
    if (
      this.formSearch.value.data &&
      this.formSearch.value.data[0] &&
      this.formSearch.value.data[1]
    ) {
      this.formSearch["dataI"] = this.format.format(
        this.formSearch.value.data[0],
        "DD/MM/YYYY",
        "en"
      );
      this.formSearch["dataF"] = this.format.format(
        this.formSearch.value.data[1],
        "DD/MM/YYYY",
        "en"
      );
    }
    if (this.formSearch.status === "INVALID") {
      Swal.fire("Vendas", `Escolha uma data`, "error");
      return;
    }

    this.usuarioService.listaVendas(
      this.formSearch,
      this.callback.bind(this),
      this.callbackError.bind(this)
    );
  }
  callback(resp) {
    if (this.list === 2) {
      this.vendas = resp;
      if (resp.length === 0) {
        this.toastService.info("Nenhum registro encontrado", "Vendas", {
          timeOut: 4000,
        });
      }
    } else if (this.list == 4) {
      this.pedidos = resp;
      this.pagTotais = resp[0].paginas;
      this.totalElements = resp[0].totalElements;
      if (resp.length === 0) {
        this.toastService.info("Nenhum registro encontrado", "Pedidos", {
          timeOut: 4000,
        });
      }
    } else if (this.list == 3) {
      this.estoque = resp.estoque;
      // if (resp.length > 0) {
      //   resp[0];
        this.pagTotais = resp.paginas;
        this.totalElements = resp.totalElements;
      // }
      if (resp.length === 0) {
        this.toastService.info("Nenhum registro encontrado", "Estoque", {
          timeOut: 4000,
        });
      }
    }
  }
  callbackError(resp) {
    Swal.fire(
      "Histórico",
      `Algo deu errado. Tente novamente mais tarde`,
      "warning"
    );
  }

  getEstoque(filtra = false) {
    if (filtra) {
      this.pageNumber = 1
    }
    this.tipo = this.formSearch.value.tipo
    this.usuarioService.getEstoque(
      { ...this.formSearch.value, page: this.pageNumber },
      this.callback.bind(this),
      this.callbackError.bind(this)
    );
  }
  getPedidos() {
    let data: any = {
      page: this.pageOrder,
      tipo:
        this.formSearch.value.status === ""
          ? "TODOS"
          : this.formSearch.value.status,
    };
    data.cliente = this.formSearch.value.cliente;
    data.usuario = this.formSearch.value.usuario;
    data.pedido = this.formSearch.value.pedido;
    data["dataInicial"] = this.format.format(
      this.formSearch.value.data[0],
      "YYYY-MM-DD",
      "en"
    );
    data["dataFinal"] = this.format.format(
      this.formSearch.value.data[1],
      "YYYY-MM-DD",
      "en"
    );
    this.pedidoService.listaPedidoV2(data, this.callback.bind(this));
    // this.usuarioService.listaRepresentante(
    //   this.form.value,
    //   this.callback.bind(this),
    //   this.callbackError.bind(this)
    // );
  }
  exportToExcel(fileName: string): void {
    function callback(resp) {
      let list = [];
      list = resp;
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, fileName + ".xlsx");
    }
    this.usuarioService.getEstoque(
      { ...this.formSearch.value, page: 0 },
      callback.bind(this),
      this.callbackError.bind(this)
    );
  }

  copyLink(link) {
    // const link = `${window.location.origin}/produto`;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        this.toastService.success(
          "Link copiado com sucesso para a área de transferência",
          "Produto",
          {
            positionClass: "toast-bottom-left",
          }
        );
      })
      .catch((err) => {
        console.error("Erro ao copiar link para a área de transferência:", err);
        this.toastService.warning(
          "Erro ao copiar link para a área de transferência",
          "Produto",
          {
            positionClass: "toast-bottom-left",
          }
        );
      });
  }

  callbackAprove(resp) {
    Swal.fire(
      "Pedido",
      `Aprovado com sucesso!`,
      "success"
    );
    this.getPedidos()
  }
  callbackAprovePix(resp) {
    this.getPedidos()
  }
  callbackReprove(resp) {
    Swal.fire(
      "Pedido",
      `Recusado com sucesso!`,
      "success"
    );
    this.getPedidos()
  }
  aprovaPedido(order) {
    if (this.pedidoAprove.status_pagamento === 'pre_pago') {
      this.usuarioService.getPix(
        {
          pedido_cliente: this.pedidoAprove.id,
        },
        function (resp) {
          this.pedidoService.aprovarPedido(
            order,
            true,
            this.callbackAprovePix.bind(this),
            this.callbackError.bind(this)
          )
          this.qrCode = resp;
          $("#pixModal").modal("show"); 
        }.bind(this),
        function (resp) {
          console.log(resp)
          this.toastService.info("Não foi possivel aprovar esse pedido! Algo deu errado!", "Pix", {
            timeOut: 4000,
          });
        }.bind(this),
      );
    } else {
      this.pedidoService.aprovarPedido(
        order,
        true,
        this.callbackAprove.bind(this),
        this.callbackError.bind(this)
      )
    }
  }
  reprovaPedido(order) {
    this.pedidoService.aprovarPedido(
      order,
      false,
      this.callbackReprove.bind(this),
      this.callbackError.bind(this)
    )
  }
}
